import { gsap } from 'gsap/all';

const NEXT = 1;
const PREV = -1;

export class Slideshow {
	DOM = {
		el: null,
		slides: null,
		slidesInner: null
	};

	current = 0;
	slidesTotal = 0;
	isAnimating = false;

	autoplayInterval = null;
	inactivityTimeout = null;
	autoplayStopped = false;
	resumeAutoplayDelay = 10000; // 10 seconds

	constructor(DOM_el) {
		this.DOM.el = DOM_el;
		this.DOM.slides = [...this.DOM.el.querySelectorAll('.slide')];
		this.DOM.slidesInner = this.DOM.slides.map(item => item.querySelector('video'));
		this.DOM.slides[this.current].classList.add('slide--current');
		this.DOM.slides[this.current].querySelector('video').play();
		this.slidesTotal = this.DOM.slides.length;
	}

	next() {
		this.navigate(NEXT);
	}

	prev() {
		this.navigate(PREV);
	}

	navigate(direction) {
		if (this.isAnimating) return false;
		this.isAnimating = true;

		const previous = this.current;
		this.current = direction === 1 ?
			(this.current < this.slidesTotal - 1 ? ++this.current : 0) :
			(this.current > 0 ? --this.current : this.slidesTotal - 1);

		const currentSlide = this.DOM.slides[previous];
		const currentInner = this.DOM.slidesInner[previous];
		const upcomingSlide = this.DOM.slides[this.current];
		const upcomingInner = this.DOM.slidesInner[this.current];

		const tl = gsap.timeline({
			defaults: {
				duration: 1.5,
				ease: 'power4.inOut'
			},
			onStart: () => {
				this.DOM.slides[this.current].classList.add('slide--current');
				this.DOM.slides[this.current].querySelector('video').play();
			},
			onComplete: () => {
				this.DOM.slides[previous].classList.remove('slide--current');
				this.DOM.slides[previous].querySelector('video').pause();
				this.isAnimating = false;
			}
		});
		tl.addLabel('start', 0)
			.to(currentSlide, { yPercent: -direction * 100 }, 'start')
			.to(currentInner, { yPercent: direction * 30 }, 'start')
			.fromTo(upcomingSlide, { yPercent: direction * 100 }, { yPercent: 0 }, 'start')
			.fromTo(upcomingInner, { yPercent: -direction * 30 }, { yPercent: 0 }, 'start');
	}

	autoplay(interval = 5000) {
		if (this.autoplayStopped) return;
		this.autoplayInterval = setInterval(() => {
			this.next();
		}, interval);
	}

	stopAutoplayTemporarily(interval = 5000) {
		if (this.autoplayInterval) {
			clearInterval(this.autoplayInterval);
			this.autoplayInterval = null;
		}
		// Clear any existing inactivity timeout
		if (this.inactivityTimeout) {
			clearTimeout(this.inactivityTimeout);
		}
		// Start new inactivity timer to resume autoplay
		this.inactivityTimeout = setTimeout(() => {
			this.autoplay(interval);
		}, this.resumeAutoplayDelay);
	}
}